import React from 'react';

function CabecalhoProjeto({ dados, onChange, editavel = true, onFileUpload, onFileUrlChange, mostrarCabecalhoCompleto = true }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    if (editavel) onChange(name, value);
  };

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  console.log("📎 Arquivo selecionado:", file);


  if (!file || !file.type.includes('pdf')) {

    alert('Por favor, selecione um arquivo PDF.');
    return;
  }

  const formData = new FormData();
  formData.append('arquivo', file);

 try {
  console.log('📤 Iniciando upload...');
  console.log('📎 Arquivo:', file.name, file.type, file.size);

  const res = await fetch('/api/anp/upload-desenho', {
    method: 'POST',
    body: formData
  });

  console.log('📬 Resposta recebida. Status:', res.status);

  const contentType = res.headers.get('content-type') || '';
  const texto = await res.text();

  console.log('🧾 Conteúdo da resposta:', texto);

  if (!res.ok) {
    console.error('❌ Erro HTTP:', res.status, texto);
    alert('Erro ao enviar o arquivo. Veja o console para detalhes.');
    return;
  }

  if (!contentType.includes('application/json')) {
    console.error('❗Resposta inesperada. Tipo:', contentType);
    return;
  }

  const json = JSON.parse(texto);
if (json.sucesso && json.url) {
  console.log('✅ Upload concluído:', json.url);

if (typeof onFileUrlChange === 'function') {
  const urlAbsoluta = 'https://projetos.impram.com.br' + json.url;
  onFileUrlChange(urlAbsoluta);
}


  if (typeof onChange === 'function') {
    onChange('arquivo', json.url);
    onChange('urlArquivo', json.url);
  }
} else {
  console.warn('⚠️ Upload falhou:', json);
  alert('Erro ao fazer upload do arquivo.');
}
} catch (err) {
  console.error('🚨 Exceção no upload:', err);
  alert('Falha ao enviar o arquivo PDF.');
}

};




// ✅ HOOK DEVE FICAR AQUI DENTRO
const [dicaCodigoCV, setDicaCodigoCV] = React.useState('');




  return (
    <div style={{ marginBottom: 16 }}>
      {mostrarCabecalhoCompleto && (
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 0,
    minHeight: 100
  }}>
    <img
      src="/logo-impram.png"
      alt="Impram Logo"
      style={{ width: 120, height: 'auto', marginBottom: 20 }}
    />
    <h1 style={{
      fontSize: 26,
      margin: 0,
      fontWeight: 700,
      letterSpacing: 1,
      lineHeight: 1.15,
      textTransform: 'uppercase',
    }}>
      ACOMPANHAMENTO DE NOVO PRODUTO - ANP
    </h1>
  </div>
)}


      {/* Botão de Anexar Desenho Técnico */}
{mostrarCabecalhoCompleto && (
  <div style={{ textAlign: 'center', marginTop: 20 }}>
    <button
      type="button"
      onClick={() => document.getElementById('file-input').click()}
      style={{
        padding: '10px 32px',
        fontWeight: 'bold',
        fontSize: 18,
        borderRadius: 20,
        border: 0,
        background: '#f8a600',
        color: '#fff',
        boxShadow: '0 1px 4px #aac',
      }}
    >
      Anexar Desenho Técnico
    </button>

    <input
      type="file"
      id="file-input"
      style={{ display: 'none' }}
      onChange={handleFileChange}
    />
  </div>
)}


      
      {/* Fieldset do formulário */}
      <fieldset style={{ margin: '2rem 0', padding: '1rem', border: '2px solid #c00', background: '#fff8f8' }}>
        <legend><b>Produção do Produto</b></legend>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: 16,
          marginBottom: 10,
          alignItems: 'end',
        }}>
          <div>
            <label>OP:<br />
              <input
  name="op"
  placeholder="Ex: IMP/1234 ou FAA/5678"
  value={dados.op || ''}
  onChange={handleInput}
  disabled={!editavel}
  style={{ width: '100%' }}
/>

            </label>
          </div>
          <div>
            <label>Cliente:<br />
              <input name="nomeCliente" value={dados.nomeCliente || ''} onChange={handleInput} disabled={!editavel} style={{ width: '100%' }} />
            </label>
          </div>
          <div>
            <label>Data da abertura da OP:<br />
              <input type="date" name="dataAberturaOP" value={dados.dataAberturaOP || ''} onChange={handleInput} disabled={!editavel} style={{ width: '100%' }} />
            </label>
          </div>
          <div>
            <label>Código IM:<br />
              <input name="codigoIM" value={dados.codigoIM || ''} onChange={handleInput} disabled={!editavel} style={{ width: '100%' }} />
            </label>
          </div>
          


<div style={{ position: 'relative' }}>
  <label>Código CV:<br />
    <input
      name="codigoCV"
      value={dados.codigoCV || ''}
      onFocus={() => {
        if (!dados.codigoCV || dados.codigoCV.length === 0) {
          setDicaCodigoCV('Digite os 4 primeiros números da FACA');
        }
      }}
onChange={(e) => {
  let raw = e.target.value.toUpperCase().replace(/^CV/, '');
  let dica = '';

  // Extrai partes
  let numeros = raw.replace(/\D/g, '').slice(0, 4);
  let resto = raw.slice(numeros.length);

  // Monta parte das letras (após ponto)
  let letras = resto.replace(/[^A-Z]/g, '').slice(0, 3);

  // Monta parte dos 3 dígitos finais (após as letras)
  let digitosFinais = resto.slice(letras.length).replace(/\D/g, '').slice(0, 3);

  // Lógica de dicas
  if (numeros.length < 4) {
    dica = 'Digite os 4 primeiros números da FACA';
  } else if (letras.length < 1) {
    dica = 'Agora digite as 3 letras do cliente';
  } else if (letras.length < 3) {
    dica = 'Continue digitando as 3 letras do cliente';
  } else if (digitosFinais.length < 3) {
    dica = 'Agora digite os 3 números da revisão da faca';
  } else {
    dica = '';
  }

  // Monta string final
  let valorFinal = `CV${numeros}`;
  if (letras.length > 0 || digitosFinais.length > 0) {
    valorFinal += `.${letras}${digitosFinais}`;
  }

  onChange('codigoCV', valorFinal);
  setDicaCodigoCV(dica);
}}


      
      disabled={!editavel}
      placeholder="CV0000.FAB123"
      style={{ width: '100%' }}
    />
  </label>

  {dicaCodigoCV && (
    <div style={{
      position: 'absolute',
      top: '100%',
      left: 0,
      background: '#f2f2f2',
      border: '1px solid #ccc',
      borderRadius: 5,
      padding: '6px 10px',
      fontSize: 13,
      color: '#333',
      marginTop: 4,
      zIndex: 10,
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      whiteSpace: 'nowrap'
    }}>
      💡 {dicaCodigoCV}
    </div>
  )}
</div>




          <div>
            <label>Data de Entrega:<br />
              <input type="date" name="dataEntrega" value={dados.dataEntrega || ''} onChange={handleInput} disabled={!editavel} style={{ width: '100%' }} />
            </label>
          </div>
        </div>
        <div style={{ marginTop: 10 }}>
          <label>Código/Descrição do Produto:<br />
            <textarea
              name="descricaoProduto"
              style={{ width: '100%', minWidth: 300, height: 60, resize: 'vertical' }}
              value={dados.descricaoProduto || ''}
              onChange={handleInput}
              disabled={!editavel}
            />
          </label>
        </div>
      </fieldset>


      
    </div>
  );
}

export default CabecalhoProjeto;
